
export default async function PhoneValidation(phone) {
	var phoneNumberPattern = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
	return phoneNumberPattern.test(phone);
}
